import React from 'react';

const ContractForm: React.FC = () => {
    return <div></div>;
};

export default ContractForm;
